import { lazy } from "react";

// Разделы панели подгружаются отдельными файлами (React.lazy). Файл может не
// прийти: оборвалась мобильная сеть — или панель обновили, пока страница была
// открыта, и старых файлов на сервере больше нет (телефон держит вкладку
// днями). Раньше такая ошибка без перехватчика снимала с экрана всё
// приложение — оставался чёрный экран до перезагрузки.
//
// Теперь: одна повторная попытка через секунду (сеть), а если и она не
// удалась — страница перезагружается сама, один раз за минуту, и берёт свежие
// файлы. Не помогло — ошибку показывает SectionErrorBoundary.

const RELOAD_KEY = "kl-chunk-reload-at";
const RELOAD_GAP_MS = 60 * 1000;

export const isChunkLoadError = (error) => {
  const text = `${error?.name || ""} ${error?.message || ""}`;
  return /ChunkLoadError|Loading (CSS )?chunk|dynamically imported module|Importing a module script failed|error loading dynamically/i.test(text);
};

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const lazyWithRetry = (factory) => lazy(async () => {
  try {
    return await factory();
  } catch (error) {
    if (!isChunkLoadError(error)) throw error;
    await wait(1000);
    try {
      return await factory();
    } catch (retryError) {
      let lastReload = 0;
      try { lastReload = Number(window.sessionStorage.getItem(RELOAD_KEY)) || 0; } catch (_) { /* хранилище недоступно */ }
      if (Date.now() - lastReload > RELOAD_GAP_MS) {
        try { window.sessionStorage.setItem(RELOAD_KEY, String(Date.now())); } catch (_) { /* перезагрузимся и так */ }
        window.location.reload();
        // Пока страница перезагружается, раздел просто ждёт.
        return new Promise(() => {});
      }
      throw retryError;
    }
  }
});
